import { ConfigKey_AdvisorHomePanel, ConfigKey_FAQ_ParentOrder, ConfigKey_FindingView_Cockpit, ConfigKey_IndependentScores } from '@app/advisor-ui-shared';
import { ConfigDialog_FAQ_ParentOrder } from './ConfigDialog_FAQ_ParentOrder/ConfigDialog_FAQ_ParentOrder.js';
import { ConfigDialog_FindingView_Cockpit } from './ConfigDialog_FindingView_Cockpit/ConfigDialog_FindingView_Cockpit.js';
import { ConfigDialog_IndependentScores } from './ConfigDialog_IndependantScores/ConfigDialog_IndependentScores.js';
import { ConfigDialog_AdvisorHomePanel } from './ConfigDialog_AdvisorHomePanel/ConfigDialog_AdvisorHomePanel.js';
export const ConfigDialogKeys_AdvisorUI = [
    ConfigKey_FAQ_ParentOrder,
    ConfigKey_FindingView_Cockpit,
    ConfigKey_IndependentScores,
    ConfigKey_AdvisorHomePanel
];
export const ConfigDialogs_AdvisorUI_Labels = {
    [ConfigKey_FAQ_ParentOrder]: 'FAQ - Parent Order',
    [ConfigKey_FindingView_Cockpit]: 'Finding View - Cockpit',
    [ConfigKey_IndependentScores]: 'Independent Scores',
    [ConfigKey_AdvisorHomePanel]: 'Advisor Home Panel'
};
export const ConfigDialogs_AdvisorUI_Dialogs = {
    [ConfigKey_FAQ_ParentOrder]: ConfigDialog_FAQ_ParentOrder,
    [ConfigKey_FindingView_Cockpit]: ConfigDialog_FindingView_Cockpit,
    [ConfigKey_IndependentScores]: ConfigDialog_IndependentScores,
    [ConfigKey_AdvisorHomePanel]: ConfigDialog_AdvisorHomePanel,
};
//# sourceMappingURL=index.js.map